import React from 'react';
import { withTranslation } from 'react-i18next';
import styles from './ErrorBoundary.module.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Caught error:', error.message, info.componentStack);
  }

  reset() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    if (this.state.hasError) {
      const { t } = this.props;
      return (
        <div className={styles.wrap}>
          <div className={styles.iconWrap}>⚠</div>
          <p className={styles.title}>
            {this.props.label || t('error_boundary.fallback')}
          </p>
          {this.state.error?.message && (
            <p className={styles.detail}>{this.state.error.message}</p>
          )}
          <button className={styles.btn} onClick={() => this.reset()}>
            {t('error_boundary.dismiss')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
